import api from "./api";

export const getsDireccionesViewByUbigeoYDetalle = async (idUbigeo, detalle) => {
    const response = await api.get(
        "/Direccion/GetDireccionesViewByUbigeoYDetalle",{params: {idUbigeo, detalle}}
    );

    return response.data.data;
}
